import { ButtonBase } from "@reusejs/react";
import SectionHeading from "../SectionHeading";
import {
  SectionContainerBase,
  TwoColumnSectionBase,
  IconTitleDescriptionActionCard,
} from "@reusejs/react";
import { PhoneIcon, MailIcon } from "@heroicons/react/outline";

let secondSectionData = {
  title: (
    <div>
      <p>Live support </p>
      <p>Chat to our experts</p>
    </div>
  ),
  description:
    "Chat with our experts who are available 24/7 to get all your queries addressed.",
};

const Icon = (props: any) => {
  return (
    <div className="flex items-center justify-center h-16 w-16 rounded-md bg-gray-100 text-gray-600">
      {props.iconObject}
    </div>
  );
};

let firstSectionFirstColData = {
  title: "Email us",
  description:
    "Email us for general queries, including marketing and partnership opportunities.",
  icon: <Icon iconObject={<MailIcon className="h-8 w-8" />} />,
  actions: (
    <a href="mailto:contact@auctionbazaar.com">contact@auctionbazaar.com</a>
  ),
};
let firstSectionSecondColData = {
  title: "Call us",
  description:
    "Call us to speak to a member of our team. We are always happy to help.",
  icon: <Icon iconObject={<PhoneIcon className="h-8 w-8" />} />,
  actions: "+91 83709 69696",
};

const SecondSectionAction = () => {
  return (
    <ButtonBase
      variant="primary"
      type="submit"
      label="Live Support"
      onClick={() => {
        console.log("button clicked");
      }}
      buttonBaseClasses={{
        font: "text-sm font-medium",
        backgroundColor: "bg-white hover:bg-blue-700",
        textColor: "text-blue-600 hover:text-white",
        border: "border hover:border hover:border-white",
        padding: "px-4 py-3",
      }}
      buttonSuffix={<div className="ml-2">&rarr;</div>}
    />
  );
};

const FirstSection = (props: any) => {
  return (
    <TwoColumnSectionBase
      firstColumnEl={
        <IconTitleDescriptionActionCard
          title={firstSectionFirstColData.title}
          icon={firstSectionFirstColData.icon}
          description={firstSectionFirstColData.description}
          actions={firstSectionFirstColData.actions}
          iconPosition="top-center"
          itemTitleDescriptionCardBaseClasses={{
            wrapper: "relative md:max-w-md px-4 py-6 sm:py-8 sm:px-16",
            iconWrapper: "flex items-center justify-center rounded-md mx-auto",
            titleWrapper: "mt-4 text-center",
            titleStyles: "text-lg md:text-xl font-bold text-gray-900",
            descriptionWrapper: "text-center mt-2",
            descriptionStyles: "text-sm md:text-base text-gray-500 font-normal",
            actionWrapper:
              "mt-2 text-sm md:text-base text-center text-blue-600 cursor-pointer font-bold md:font-medium",
          }}
        />
      }
      secondColumnEl={
        <IconTitleDescriptionActionCard
          title={firstSectionSecondColData.title}
          icon={firstSectionSecondColData.icon}
          description={firstSectionSecondColData.description}
          actions={firstSectionSecondColData.actions}
          iconPosition="top-center"
          itemTitleDescriptionCardBaseClasses={{
            wrapper: "relative md:max-w-md px-4 py-6 sm:py-8 sm:px-16",
            iconWrapper: "flex items-center justify-center rounded-md mx-auto",
            titleWrapper: "mt-4 text-center",
            titleStyles: "text-lg md:text-xl font-bold text-gray-900",
            descriptionWrapper: "text-center mt-2",
            descriptionStyles: "text-sm md:text-base text-gray-500 font-normal",
            actionWrapper:
              "mt-2 text-sm md:text-base text-center text-blue-600 cursor-pointer font-bold md:font-medium",
          }}
        />
      }
      twoColumnSectionBaseClasses={{
        firstElWrapperStyles:
          "w-full flex justify-center 2xl:justify-end border-b pt-8",
        secondElWrapperStyles:
          "w-full flex justify-center 2xl:justify-end border-b pb-8", //p-12
        columnsFlexWrapperStyles: "flex items-center justify-between  flex-col",
      }}
    />
  );
};

const SecondSection = (props: any) => {
  return (
    <SectionHeading
      title={secondSectionData.title}
      description={secondSectionData.description}
      actions={<SecondSectionAction />}
      itemTitleDescriptionCardBaseClasses={{
        wrapper: "relative lg:max-w-md",
        titleWrapper: "mt-2 text-left lg:pr-28",
        titleStyles:
          "text-2xl md:text-4xl md:w-full md:text-3xl font-extrabold text-white tracking-tight",
        descriptionWrapper: "text-left mt-6 lg:pr-24",
        descriptionStyles: "text-xl md:text-base text-gray-300 font-normal",
        actionWrapper:
          "mt-6 text-left text-blue-600 font-medium md:font-normal",
      }}
    />
  );
};

export default function Support() {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "bg-white overflow-hidden",
        innerContainerStyles: "relative w-full mx-auto",
      }}
    >
      <TwoColumnSectionBase
        firstColumnEl={<FirstSection />}
        secondColumnEl={<SecondSection />}
        twoColumnSectionBaseClasses={{
          firstElWrapperStyles: "w-full md:w-2/5",
          secondElWrapperStyles:
            "w-full flex items-center bg-blue-600 md:w-3/5 self-stretch px-4 py-8 md:px-20",
          columnsFlexWrapperStyles:
            "flex items-center justify-between flex-col md:flex-row",
        }}
      />
    </SectionContainerBase>
  );
}
